export default __webpack_public_path__ + "static/media/metamask.025eadf5.svg";